"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Menu = _interopRequireDefault(require("@eig-builder/core-ui/Menu"));

var StyledMenu = (0, _styles.withStyles)({
  paper: {
    border: "1px solid ".concat(function (props) {
      return props.theme.palette.border.main;
    }),
    minWidth: '196px',
    maxHeight: '100%',
    '& > ul > div:focus': {
      outline: 'none'
    }
  }
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Menu["default"], (0, _extends2["default"])({
    elevation: 1,
    getContentAnchorEl: null
  }, props));
});

var StyledDropdownMenu = function StyledDropdownMenu(_ref) {
  var actionElement = _ref.actionElement,
      children = _ref.children,
      anchorOrigin = _ref.anchorOrigin,
      transformOrigin = _ref.transformOrigin,
      className = _ref.className;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, _react["default"].cloneElement(actionElement, {
    onClick: handleClick,
    className: open ? 'open' : null
  }), /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin
  }, _react["default"].Children.map(children, function (child) {
    return _react["default"].cloneElement(child, {
      onClick: function onClick() {
        if (child.props.onClick) {
          child.props.onClick();
        }

        handleClose();
      }
    });
  })));
};

StyledDropdownMenu.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]).isRequired,
  actionElement: _propTypes["default"].any.isRequired,
  anchorOrigin: _propTypes["default"].object,
  transformOrigin: _propTypes["default"].object,
  className: _propTypes["default"].string
};
StyledDropdownMenu.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right'
  }
};
var _default = StyledDropdownMenu;
exports["default"] = _default;